export default [
  '#661A1A',
  '#979973',
  '#00B3FF',
  '#CC007A',
  '#E6ACC6',
  '#665E1A',
  '#40FF53',
  '#203880',
  '#806064',
  '#F07E8F',
  '#50994D',
  '#4D8299',
  '#AC80FF',
  '#4C2200',
  '#E81123',
  '#1A664F',
  '#4E4D66',
  '#663359',
  '#FFE600',
  '#107C10',
  '#5180FF',
  '#CC66C2',
  '#FF2265',
  '#A9E639',
  '#0078D7',
  '#080099',
  '#B27459',
  '#994500',
  '#00E6A1',
  '#EA005E',
  '#FF38EB',
  '#E58A00',
  '#CCA633',
  '#394D4D',
  '#7A7574',
  '#4C0022',
  '#50521E',
  '#00B3B3',
  '#004766',
  '#881798',
  '#CC3D00',
  '#0E4E1D',
  '#13194D',
  '#645BFF',
  '#FF7C2F',
  '#663D00',
  '#034661',
  '#C0ACE6',
  '#D52CFF',
  '#6D8AB0',
];
